<script setup lang="ts">
const props = defineProps({
  iconClass: {
    type: String,
    default: '',
  },
  defaultFill: {
    type: Boolean,
    default: true,
  },
})
</script>

<template>
  <svg width="27" height="23.232" viewBox="-3.5 -1.744 18 15.488" :class="iconClass">
    <path
      :fill="defaultFill ? '#C33' : ''"
      d="M14.125 9.96L7.609-.568A2.463 2.463 0 005.5-1.744c-.866 0-1.654.439-2.109 1.176L-3.125 9.961a2.45 2.45 0 00-.057 2.511 2.448 2.448 0 002.166 1.272h13.031c.912 0 1.721-.476 2.166-1.272a2.453 2.453 0 00-.056-2.512zm-1.504 1.643a.682.682 0 01-.605.355H-1.016a.687.687 0 01-.606-.355.687.687 0 01.016-.703L4.906.377 4.91.371A.678.678 0 015.5.042a.68.68 0 01.59.329l6.516 10.528c.134.218.14.481.015.704zm-8.014-.881h1.786V8.937H4.607v1.785zm0-3.048h1.786V3.002H4.607v4.672z"
    />
  </svg>
</template>

<style scoped></style>
